import * as type from './types';
import { createReducer } from "../../util/index";

//Set the initial state for the current page , current limit and current search values
const initialState = {
    data: []
};

const financialReportReducer = createReducer(initialState) ({
    [type.LIST]: (state, action) => ({
        ...state,
        list: action.payload,
    }),
});

export default financialReportReducer;